<template>
  <div class="main-content">
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-12 col-md-5 col-xl-6">
          <h2 class="header-title">Список абитуриентов</h2>
        </div>
        <div class="col-12 col-md-7 col-xl-6 d-flex">
          <div class="input-affix mr-4">
            <i class="prefix-icon anticon anticon-search"></i>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model.trim="searchText"
              placeholder="Поиск"
              @input="searchInput" @keydown.enter="searchFio"
            />
            <i class="suffix-icon close anticon anticon-close" v-if="searchText.length" @click="searchText=''"></i>
          </div>
          <button
            class="btn btn-primary"
            style="white-space: nowrap"
            @click="modalShow"
          >
            Добавить
          </button>
        </div>
      </div>
    </div>
    <!-- Content goes Here -->
    <div class="card">
      <div class="card-body">
        <template v-if="regUsersList.data.length">
          <div class="row align-items-center">
            <div class="col-auto mb-2">
              <span class="mr-3">
                {{ perPage }} из {{ regUsersList.total }}
              </span>
              <span class="mr-2">Покозать:</span>
              <select
                class="custom-select custom-select-sm"
                style="width: 5em"
                v-model="perPage"
                @change="perPageChange"
              >
                <option
                  v-for="(item, index) in perPageArr"
                  :value="item"
                  :key="index"
                >
                  {{ item }}
                </option>
              </select>
            </div>
            <div class="col-auto ml-auto mb-2">
              <div class="row">
                <div class="col-auto"></div>
                <div class="col-auto">
                  <button
                    class="btn btn-sm btn-icon btn-secondary btn-tone excel"
                    :disabled="!regUsersList.data.length"
                    :class="{ excelHide: !regUsersList.data.length }"
                    @click="downloadFile"
                  >
                    <i class="anticon anticon-file-excel"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-0 mb-2" />        
          <table
            class="table table-responsive-md table-striped table-hover table-sm"
          >
            <thead class="">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Фамилия</th>
                <th scope="col">Имя</th>
                <th scope="col">Отчество</th>
                <th scope="col">Тел. номер</th>
                <th scope="col">Email</th>
                <th scope="col">Дата рег.</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in regUsersList.data" :key="item.id">
                <th scope="row">{{ (page - 1) * perPage + (index + 1) }}</th>
                <td>{{ item.f }}</td>
                <td>{{ item.i }}</td>
                <td>{{ item.o }}</td>
                <td>{{ item.mob_number }}</td>
                <td>{{ item.email }}</td>
                <td>{{ new Date(item.created_at).toLocaleString() }}</td>

                <td class="text-right">
                  <!-- <button class="btn btn-primary btn-xs mr-1">btn-xs</button> -->
                  <button
                    class="btn btn-icon btn-sm btn-primary btn-tone mr-1 mb-1 mb-lg-0"
                    v-if="item.abiturient_doc == null"
                    @click="goStatement(item.id)"
                  >
                    <i class="anticon anticon-bars"></i>
                  </button>
                  <button
                    class="btn btn-icon btn-sm btn-success btn-tone mr-1 mb-1 mb-lg-0"
                    disabled
                  >
                    <i class="anticon anticon-edit"></i>
                  </button>
                  <button
                    class="btn btn-icon btn-sm btn-danger btn-tone"
                    disabled
                  >
                    <i class="anticon anticon-delete"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </template>
        <template v-else >
          <div v-if="dataLoading" class="loadData"><i class="anticon anticon-loading"></i></div>
          <div v-else class="noTdData">Нет данных</div>          
        </template>
        <nav
          class="d-flex justify-content-center"
          v-if="regUsersList.data.length"
        >
          <ul class="pagination">
            <li
              class="page-item"
              v-for="(item, i) in regUsersList.links"
              :key="i"
              :class="{ active: item.active, disabled: item.url == null }"
              @click.prevent="slectPage(i)"
            >
              <a class="page-link" href="#">
                <template v-if="item.label === '&laquo; Previous'">
                  <i class="anticon anticon-double-left"></i>
                </template>
                <template v-else-if="item.label === 'Next &raquo;'">
                  <i class="anticon anticon-double-right"></i>
                </template>
                <template v-else>{{ item.label }}</template>
              </a>
            </li>           
          </ul>
        </nav>
      </div>
    </div>

    <Modal :isShow="isModalShow" @closeModal="closeModal">
      <template v-slot:title>Регистрация</template>
      <template>
        <form action="#">
          <div class="form-group">
            <label class="font-weight-semibold" for="f">Фамилия:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-user"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="f"
                placeholder="Эшматов"
                v-model.trim="user.f"
                :class="[
                  { 'is-invalid': $v.user.f.$error },
                  { 'is-valid': $v.user.f.required },
                ]"
                @blur="$v.user.f.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.f.required && $v.user.f.$dirty"
            >
              Это поле обязательно
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-semibold" for="i">Имя:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-user"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="i"
                placeholder="Ташмат"
                v-model.trim="user.i"
                :class="[
                  { 'is-invalid': $v.user.i.$error },
                  { 'is-valid': $v.user.i.required },
                ]"
                @blur="$v.user.i.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.i.required && $v.user.i.$dirty"
            >
              Это поле обязательно
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-semibold" for="o">Отчество:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-user"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="o"
                placeholder="Полотович"
                v-model.trim="user.o"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-semibold" for="number"
              >Номер телефона:</label
            >
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-phone"></i>
              <input
                type="text"
                class="form-control form-control-sm"
                id="number"
                placeholder="0123456789"
                v-model.trim="user.mob_number"
                :class="[
                  { 'is-invalid': $v.user.mob_number.$error },
                  { 'is-valid': $v.user.mob_number.required },
                ]"
                @blur="$v.user.mob_number.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.mob_number.required && $v.user.email.$dirty"
            >
              Поле номер телефона обязательно
            </div>
          </div>
          <div class="form-group">
            <label class="font-weight-semibold" for="email">Email:</label>
            <div class="input-affix">
              <i class="prefix-icon anticon anticon-mail"></i>
              <input
                type="email"
                class="form-control form-control-sm"
                id="email"
                placeholder="Email"
                v-model.trim="user.email"
                :class="[
                  { 'is-invalid': $v.user.email.$error },
                  { 'is-valid': $v.user.email.required && $v.user.email.email },
                ]"
                @blur="$v.user.email.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.email.required && $v.user.email.$dirty"
            >
              Поле электронной почты обязательно
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.email.email && $v.user.email.$dirty"
            >
              Это поле должно быть адресом электронной почты
            </div>
          </div>

          <div class="form-group">
            <label class="font-weight-semibold" for="password">Пароль:</label>
            <div class="input-affix m-b-10">
              <i class="prefix-icon anticon anticon-lock"></i>
              <input
                type="password"
                class="form-control form-control-sm"
                id="password"
                placeholder="*****"
                v-model.trim="user.password"
                :class="[
                  { 'is-invalid': $v.user.password.$error },
                  {
                    'is-valid':
                      $v.user.password.required && $v.user.password.minLength,
                  },
                ]"
                @blur="$v.user.password.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.password.required && $v.user.password.$dirty"
            >
              Поле пароля почты обязательно
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.password.minLength && $v.user.password.$dirty"
            >
              Это поле должно быть минимум 6 символов
            </div>
          </div>

          <div class="form-group mb-0">
            <label class="font-weight-semibold" for="confirm"
              >Подтвердить пароль:</label
            >
            <div class="input-affix m-b-10">
              <i class="prefix-icon anticon anticon-lock"></i>
              <input
                type="password"
                class="form-control form-control-sm"
                id="confirm"
                placeholder="*****"
                v-model.trim="user.confirm"
                :class="[
                  { 'is-invalid': $v.user.confirm.$error },
                  {
                    'is-valid':
                      $v.user.confirm.required && $v.user.confirm.sameAs,
                  },
                ]"
                @blur="$v.user.confirm.$touch()"
              />
            </div>
            <div
              class="invalid-feedback"
              v-if="!$v.user.confirm.required && $v.user.password.$dirty"
            >
              Поле пароля почты обязательно
            </div>
            <div
              class="invalid-feedback"
              v-if="$v.user.confirm.$error && $v.user.confirm.$dirty"
            >
              Пароль должен совпадать
            </div>
          </div>
        </form>
      </template>

      <template v-slot:footer>
        <div class="d-flex justify-content-center">
          <button
            type="reset"
            class="btn btn-secondary mr-3"
            @click="closeModal"
          >
            Отмена
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            @click.prevent="formSubmit"
          >
            Подтвердитьь
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import xlsx from "json-as-xlsx";
import _ from "lodash";

import Modal from "@/components/others/Modal.vue";

import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: "St_list",
  mixins: [validationMixin],
  components: {
    Modal,
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
  },
  data() {
    return {
      isModalShow: false,
      regUsersList: {
        data: [],
        links: [],
      },
      page: 1,
      perPage: 10,
      perPageArr: [5, 10, 15, 25, 50, 100],
      searchText: "",
      dataLoading: false,
      tur: { items: null, val: 0 },
      user: {
        f: "",
        i: "",
        o: "",
        mob_number: "",
        email: "",
        password: "",
        confirm: "",
      },
    };
  },
  validations: {
    user: {
      f: { required },
      i: { required },
      mob_number: { required },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      confirm: { required, sameAs: sameAs("password") },
    },
  },
  methods: {
    goStatement(id) {
      let d = this.regUsersList.data.filter((i) => i.id == id)[0];
      this.$router.push({
        name: "StatementEdit",
        params: { status: 0, id: d.id, f: d.f, i: d.i, o: d.o },
      });
    },
    slectPage(i) {
      let p = this.regUsersList.links[i];
      if (parseInt(p.label)) {
        this.page = parseInt(p.label);
        this.regUsersList = {};
        this.get_list();
      } else {
        if (p.label == "&laquo; Previous" && p.url != null) {
          this.page--;
          this.regUsersList = {};
          this.get_list();
        }
        if (p.label == "Next &raquo;" && p.url != null) {
          this.page++;
          this.regUsersList = {};
          this.get_list();
        }
      }
    },
    perPageChange() {
      this.get_list();
    },
    downloadFile() {
      let data = [
        {
          sheet: "Студент",
          columns: [
            { label: "#", value: "num" },
            { label: "ФИО", value: (row)=>row.f + ' ' + row.i + ' ' + row.o },            
            { label: "Тел. номер", value: "mob_number" },
            { label: "Email", value: "email" },
          ],
          content: this.regUsersList.data.map((еl, index)=>({
              num: index+1,
              f: еl.f,
              i: еl.i,
              o: еl.o,
              mob_number: еl.mob_number,
              email: еl.email,            
            })),
        },
      ];
      let settings = {
        fileName: "Студент",
      };
      xlsx(data, settings);
    },
    modalShow() {
      this.isModalShow = true;
    },
    closeModal() {
      this.isModalShow = false;
    },
    formSubmit() {
      if (this.$v.$invalid) {
        this.$v.user.$touch();
      } else {
        this.signUp();
      }
    },

    async signUp() {
      try {
        await this.$api.auth.signUp({
          f: this.user.f,
          i: this.user.i,
          o: this.user.o,
          mob_number: this.user.mob_number,
          email: this.user.email,
          password: this.user.password,
        });

        this.regUsersList = [];
        this.closeModal();
        this.get_list();
      } catch (error) {
        if (error.response.status == 409) {
          console.log("409");
        }
      }
    },
    async get_list() {
      this.dataLoading = true
      try {
        const data = (
          await this.$api.user.get_list({
            page: this.page,
            perPage: this.perPage,
            searchByFio: this.searchText
          })
        ).data;
        this.regUsersList = data;
        this.dataLoading = false
      } catch (error) {
        if (error.response.status == 401) {
          this.$router.push("/");
        }
      }
    },
    searchFio(){       
      this.page = 1       
      this.get_document().then(()=>{
        this.searchByFio = ''
      })      
    },
    searchInput(){
      if (this.searchText.length>3 || this.searchText.length==0) this.antiRebote(this.get_list)      
    },
    antiRebote: _.debounce((cb, arg)=>{cb(arg)}, 350),
  },
  mounted() {
    this.$nextTick(function () {
      this.get_list();
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.modal .form-group {
  margin-bottom: 1em;
}
.input-affix.anticon-search .form-control-sm {
   padding-right: 35px;
}
</style>
